import { ReactNode } from 'react';
import styles from './styles.module.scss';
import typography from '@/styles/typography.module.scss';
import classNames from 'classnames';

export function RankingCardHeader(props: { icon: React.ReactNode; title: ReactNode }) {
  return (
    <div className={classNames(styles.cardHeader, typography.h4)}>
      {props.icon}
      {props.title}
    </div>
  );
}
